<div class="message-container">
    <p-card>
        <h1 [class.error]="hasError">
            @if(isLoading){
            Loading...
            }@else{
            {{message}}
            }
        </h1>
    </p-card>

    <app-loading [loading]="isLoading"></app-loading>

</div>